export const PAYMENT_METHODS = {
  CARD_NOW: 'card-now',
  CARD_ARRIVE: 'card-arrive',
  CASH_ARRIVE: 'cash-arrive',
}
